<template>
  <roe-error-message :field="design.auto_increase_date_type">
    <v-select
      v-model="design.$model.auto_increase_date_type"
      name="auto_increase_date_type"
      :options="selectOptions.auto_increase_date_type"
      :reduce="label => label.code"
      required
    >
    </v-select>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import { AutoIncreaseMixin } from "@/components/_shared/inputs/design/_mixins";
import { mapGetters } from "vuex";
export default {
  name: "RoeAutoIncreaseDateTypeSelect",
  components: { RoeErrorMessage },
  mixins: [AutoIncreaseMixin],
  props: {
    design: Object
  },
  computed: {
    ...mapGetters(["selectOptions"])
  }
};
</script>
